import React from 'react'
import Link from 'next/link'
import { Image } from '@/components/elements/Image'
import { formatDateAndMonth } from '@/utils/formatDate'

export interface BillboardCardProps {
  id: string
  originalTitle: string
  authorship: string
  photo: string
  date: string
  last?: boolean
}

export const BillboardCard: React.FC<BillboardCardProps> = ({
  id,
  originalTitle,
  authorship,
  photo,
  date,
}) => (
  <Link href={`/pelicules/${id}`} passHref>
    <div
      className="flex flex-col pb-5 text-navy-700 cursor-pointer md:pb-10"
      key={id}
    >
      <div className="aspect-w-6 aspect-h-5 md:aspect-w-16 md:aspect-h-9">
        <Image
          src={photo}
          alt={originalTitle}
          layout="fill"
          objectFit="cover"
        />
      </div>
      <div className="flex flex-col mt-4">
        <p className="break-words text-2xl font-black md:text-3xl">
          {originalTitle}
        </p>
        <p className="mb-4 mt-1 text-lg">{authorship}</p>
        <p className="text-navy-light-700 text-sm uppercase md:text-lg md:normal-case">
          {formatDateAndMonth(date)}
        </p>
      </div>
    </div>
  </Link>
)
